











import { Component, Vue, Prop } from 'vue-property-decorator'
import { RoomMember } from '@/class/roomMember'
import HeadlineBorder from '@/components/Utils/headline/HeadlineBorder.vue'

@Component({
  components: {
    HeadlineBorder
  }
})
export default class RoomMemberList extends Vue {
  @Prop() roomMembers!: RoomMember[];
}
